module.exports = __webpack_public_path__ + "img/recharge-transactions.c3e21155.jpg";